import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'
import Header, { SidePopupHeaderProps } from './Header'

export interface SidePopupBodyProps {
  headerProps: SidePopupHeaderProps
  children: JSX.Element | JSX.Element[] | string | string[]
}

const SidePopupBody = ({ headerProps, children }: SidePopupBodyProps) => {
  const headerRef = useRef<HTMLDivElement>()
  const [headerHeight, setHeaderHeight] = useState(63)

  useEffect(() => {
    if (headerRef.current?.clientHeight) {
      setHeaderHeight(headerRef.current.clientHeight)
    }
  }, [headerProps])

  return (
    <div className="relative flex w-[100%] flex-col items-start justify-start">
      <Header {...headerProps} headerRef={headerRef} />
      <div
        className={`flex min-h-full w-full items-start justify-start overflow-y-scroll px-[20px] pt-[20px]`}
        style={{
          marginTop: `${headerHeight}px`,
        }}
      >
        {children}
        <div className="h-full"></div>
      </div>
    </div>
  )
}
const Content = ({
  headerHeight,
  children,
}: {
  headerHeight: number
  children: JSX.Element | JSX.Element[] | string | string[]
}) => {
  return (
    <div
      className={classNames(`flex min-h-full w-full items-start justify-start overflow-y-scroll px-[20px] pt-[20px]`, {
        [`mt-[${headerHeight + 1}px]`]: true,
      })}
    >
      {children}
      <div className="h-full"></div>
    </div>
  )
}

export default SidePopupBody
